export default function(state = '', action) {
        switch (action.type) {
            case 'SET_THEME': {
                return action.value;
            }
            default: {
                return state;
            }
        }
    }